import type { ReactNode } from 'react';

export const symbol_business_messages: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M240-160q-24 0-42-18t-18-42v-413L81-751q-4-5-5.5-9.51-1.5-4.52-1.5-9.38 0-11.11 8.25-20.61T104-800h716q24 0 42 18t18 42v520q0 24-18 42t-42 18H240Zm-71-580 71 84v436h580v-520H169Zm337 367h179q12.75 0 21.38-8.68 8.62-8.67 8.62-21.5 0-12.82-8.62-21.32-8.63-8.5-21.38-8.5H433q-19.69 0-27.34 18.5Q398-396 412-382l94 92q9 8 21 8.5t21-8.5q9-9 8.5-21.5T547-333l-41-40Zm63-214H390q-12.75 0-21.37 8.68-8.63 8.67-8.63 21.5 0 12.82 8.63 21.32 8.62 8.5 21.37 8.5h251q19.69 0 27.34-18.5Q676-564 662-578l-93-92q-8.07-8-20.53-8-12.47 0-21.47 8.5-9 8.5-8.5 21T528-627l41 40Zm-74 107Z"
		/>
	</svg>
);
